import components from './_components';
import methods from './_methods';
import mixins from './../_mixins-missmatch-monitor';

export default {
    name: 'TabDateDetails',
    mixins: [mixins],
    components,
    methods,
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            items: [],
            actionSelected: 'ninguna',
            mismatchesItemSelected: [],
            selectedItems: []
        };
    },
    async mounted() {
        this.$root.$on('showModalWarningAction', show => {
            if (show) {
                this.$bvModal.show('modalWarningAction');
            } else {
                this.$bvModal.hide('modalWarningAction');
            }
        });
        this.$root.$on('createFusionOperation', item => {
            if (item[0]?._origin === 'tab-date-details') {
                this.createFusion(item);
            }
        });
        this.$root.$on('addOperation', item => {
            if (item[0]?._origin === 'tab-date-details') {
                this.addOperation(item);
            }
        });
        this.$root.$on('addFusionAllOperations', item => {
            this.addFusionAllOperations(item);
        });
        this.$root.$on('addFusionSelectedOperations', item => {
            this.addFusionSelectedOperations(item);
        });
        await this.fetchData();
    },
    beforeDestroy() {
        this.$root.$off('showModalWarningAction');
        this.$root.$off('createFusionOperation');
        this.$root.$off('addFusionAllOperations');
        this.$root.$off('addFusionSelectedOperations');
        this.$root.$off('addOperation');
    },
    computed: {
        // Formateamos los datos recibidos desde el componente padre
        itemsFormated() {
            return this.items.map(x => {
                const items = {
                    uuid: x.uuid,
                    yuri_operation: x.yuri_operation,
                    id_object: x.rd_operation.id_object,
                    id_object_account: x.id_object_account,
                    operation_date: x.rd_operation.operation_date,
                    nav: x.rd_operation.nav,
                    key_product: x.rd_operation.key_product.replace('COBAS', 'INNOCAPITAL'), // TODO quitar esto en cuanto se pueda,
                    name_product: x.name_product.replace('Cobas', 'Innocapital'), // TODO quitar esto en cuanto se pueda
                    key_operation_type: x.rd_operation.key_operation_type,
                    key_sub_operation_type: x.rd_operation.key_sub_operation_type,
                    shares: x.rd_operation.shares,
                    gross_amount: x.rd_operation.gross_amount,
                    withholding: x.rd_operation.withholding,
                    commission: x.rd_operation.commission,
                    net_amount: x.rd_operation.net_amount,
                    show_details: true,
                    processed: x.processed,
                    actionData: {
                        match: true,
                        uuid: x.yuri_operation ? x.yuri_operation.uuid : null,
                        uuid_account: x.uuid_account,
                        uuid_daily_summary: x.uuid_daily_summmary || null,
                        uuid_mismatched_operation: x.uuid || null,
                        ...x.rd_operation
                    }

                };
                return items;
            });
          },
        itemsReaming() {
            return this.itemsFormated.filter(item => !item.processed);
        },
        // Columnas que queremos mostrar en la tabla
        fields() {
            return [
                'selected',
                'id_object',
                'id_object_account',
                'operation_date',
                'key_product',
                'key_operation_type',
                'key_sub_operation_type',
                'shares',
                'nav',
                'withholding',
                'commission',
                'gross_amount',
                'net_amount',
                'show_details'
            ];
        }
    }
};
